import { render, staticRenderFns } from "./imggs.vue?vue&type=template&id=fa6c8430&"
import script from "./imggs.vue?vue&type=script&lang=js&"
export * from "./imggs.vue?vue&type=script&lang=js&"
import style0 from "./imggs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports